import { defineStore } from 'pinia'

// 定义 store
export const useMainStore = defineStore('main', {
	state: () => ({
		userInfo: {},
		token: '',
		school: {},
		ssoUser: {},
		sysModel: {}
	}),
	getters: {
		getUserInfo(state) {
			return state.userInfo
		},
		getToken(state) {
			return state.token
		},
		getSchool(state) {
			return state.school
		},
		getSSOUser(state) {
			return state.ssoUser
		},
		getSysInfo(state) {
			return state.sysModel
		}
	},
	persist: true,//数据持久化
	actions: {
		setUserInfo(users) {
			this.userInfo = users
		},
		setToken(token) {
			this.token = token
		},
		setSchool(school) {
			this.school = school
		},
		setSSOUser(obj) {
			this.ssoUser = obj
		},
		setSysInfo(obj) {
			this.sysModel = obj
		}
	}
})